__turbopack_context__.v({
  "backBtn": "Sidebar-module__0RD8IG__backBtn",
  "backWrapper": "Sidebar-module__0RD8IG__backWrapper",
  "collapsed": "Sidebar-module__0RD8IG__collapsed",
  "configurator": "Sidebar-module__0RD8IG__configurator",
  "container": "Sidebar-module__0RD8IG__container",
  "footer": "Sidebar-module__0RD8IG__footer",
  "header": "Sidebar-module__0RD8IG__header",
  "logoWrapper": "Sidebar-module__0RD8IG__logoWrapper",
  "nav": "Sidebar-module__0RD8IG__nav",
  "navLink": "Sidebar-module__0RD8IG__navLink",
  "navLinkActive": "Sidebar-module__0RD8IG__navLinkActive",
  "navLinkCollapsed": "Sidebar-module__0RD8IG__navLinkCollapsed",
  "navSectionBlock": "Sidebar-module__0RD8IG__navSectionBlock",
  "toggleBtn": "Sidebar-module__0RD8IG__toggleBtn",
  "viewSwitch": "Sidebar-module__0RD8IG__viewSwitch",
  "viewSwitchBtn": "Sidebar-module__0RD8IG__viewSwitchBtn",
  "viewSwitchBtnActive": "Sidebar-module__0RD8IG__viewSwitchBtnActive",
  "viewSwitchCollapsed": "Sidebar-module__0RD8IG__viewSwitchCollapsed",
  "wrapper": "Sidebar-module__0RD8IG__wrapper",
});
